import emailMisspelled, { top100 } from 'email-misspelled';
import { useState, useCallback } from 'react';

import { noop } from '@perpay-web/utils/noop';

const useEmailMisspelled = (onChange = noop) => {
    const checker = emailMisspelled({ domains: top100 });
    const [suggestions, setSuggestions] = useState([]);

    const checkEmail = useCallback(
        (email) => {
            const correctedSuggestions = checker(email);
            if (correctedSuggestions) {
                setSuggestions(correctedSuggestions);
            } else {
                setSuggestions(null);
            }
        },
        [checker],
    );

    const handleEmailChange = useCallback(
        (email) => {
            checkEmail(email);
            onChange(email);
        },
        [checkEmail, onChange],
    );

    return {
        suggestions,
        setSuggestions,
        checkEmail,
        handleEmailChange,
    };
};

export default useEmailMisspelled;
